import { useFormStore } from "components/ProjectSpecificComponents/Contexts/FormStoreContext"
import { useStore } from "components/ProjectSpecificComponents/Contexts/GlobalStoreContext"
import { observer } from "mobx-react"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import NewRequestFormModal from "../../../Global/molecules/Modals/NewRequestFormModal"
import AdminPanelFormSection from "../../molecules/AdminPanelFormSection"
import NewRequestForm from "../../molecules/Forms/NewRequestForm"
import { useInView } from "react-intersection-observer"

interface Props {
	id?: string
}

const NewRequestFormSection = observer(({ id }: Props) => {
	const formStore = useFormStore()
	const { t } = useTranslation()
	const [isPreviewModalShown, setIsPreviewModalShown] = useState<boolean>(false)

	const store = useStore()
	const { ref, inView } = useInView()
	useEffect(() => {
		store.setSectionIsInView({ section: "newRequestForm", inView })
	}, [inView])

	return (
		<>
			<div id={id} ref={ref}>
				<AdminPanelFormSection
				    language={"newRequestLanguage"}
					buttonsType="add-preview-delete"
					title={t(`forms.header.newRequestForm`)}
					tooltipText={t(`forms.tooltip.newRequestForm`)}
					onClickAddField={() => formStore.insertNewFieldIntoForm("newRequestForm")}
					onClickPreview={() => setIsPreviewModalShown(true)}
					onClickDeleteFields={() => formStore.resetMultiFieldForm("newRequestForm")}
				>
					<NewRequestForm />
				</AdminPanelFormSection>
			</div>

			{isPreviewModalShown && formStore.selectedFormsConfig && (
				<NewRequestFormModal
					mode="preview"
					config={formStore.selectedFormsConfig.newRequestForm}
					onClose={() => setIsPreviewModalShown(false)}
				/>
			)}
		</>
	)
})

export default NewRequestFormSection
